import { useState } from "react";
import TextComponent from "../../../../components/textComponent/TextComponent";
import { Bar } from "react-chartjs-2";
import styles from "./BarChart.module.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(
  ArcElement,
  LinearScale,
  Tooltip,
  Legend,
  CategoryScale,
  BarElement,
  Title,
  Legend
);

const BarChart = ({ chartData }) => {
  return (
    <div className={styles.chartContainer}>
      <Bar
        width={"90%"} // Example width in pixels
        height={2000} // Example height in pixels
        data={chartData}
        options={{
          maintainAspectRatio: false,
          indexAxis: "x",
          scales: {
            y: {
              beginAtZero: true,
              max: 25,
              ticks: {
                display: false,
              },
              grid: {
                display: false,
                drawBorder: false,
              },
            },
            x: {
              grid: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                font: {
                  size: 14,
                },
              },
            },
          },
          plugins: {
            title: {
              display: true,
            },
            tooltip: {
              display: false,
            },
            legend: {
              display: false,
              position: "bottom",
            },
          },
          responsive: true,
        }}
      />
    </div>
  );
};
export default BarChart;
